module.exports = __webpack_public_path__ + "assets/img/visa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/service-logos/visa.svg
// module id = 77
// module chunks = 0